import { clamp, memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file

const resultFunction = (logger) =>
  memoize(
    ({ asset, getBalance, provider }) => {
      try {
        const minSellAmount = asset.providers[provider]?.minSellAmount ?? 0
        const maxSellAmount = asset.providers[provider]?.maxSellAmount ?? Number.MAX_SAFE_INTEGER
        const assetBalance = getBalance(asset.name).toDefaultNumber()
        const balance = clamp(
          assetBalance,
          minSellAmount ?? assetBalance,
          maxSellAmount ?? assetBalance
        )

        if (!assetBalance || assetBalance < minSellAmount) {
          return minSellAmount || 0
        }

        return balance
      } catch (error) {
        logger.error('Failed to subtract fee', error)
      }

      return 0
    },
    (assetName, providerName) => `${assetName}.${providerName}`
  )

const getAvailableSellBalanceSelectorDefinition = {
  id: 'getAvailableSellBalance',
  resultFunction,
  dependencies: [{ selector: 'logger' }],
}

export default getAvailableSellBalanceSelectorDefinition
